t = require('app/scripts/views/internal/teacup-with-helpers')('card_title_on_card_front')

module.exports = t.renderable ({ idShort, name, separatorClassName }) ->
  # guide/hacks/id-short
  if idShort
    t.span '.card-short-id.hide', ->
      t.format 'idshort', { idShort: idShort }
  if separatorClassName
    t.div ".#{separatorClassName}"
  else
    t.text name
